import { supabase } from "../lib/supabaseClient";

// Get redirect URL based on environment (local vs production)
const getRedirectUrl = () => {
  const isLocal =
    typeof window !== "undefined" &&
    (window.location.hostname === "localhost" ||
      window.location.hostname === "127.0.0.1");

  if (isLocal) {
    return `${window.location.origin}/auth/callback`;
  }
  
  // Use environment variable if available, otherwise fallback to production
  // Note: React requires REACT_APP_ prefix for env vars to be accessible in browser
  return (
    process.env.REACT_APP_REDIRECT_URL || "https://paper-pulse-drab.vercel.app/auth/callback"
  );
};

export const signInWithGithub = async () => {
  const redirect_url = getRedirectUrl();
  
  if (!redirect_url || !redirect_url.startsWith("http")) {
    console.error("Invalid redirect URL:", redirect_url);
    throw new Error("Invalid redirect URL configuration");
  }
  
  try {
    const { data, error } = await supabase.auth.signInWithOAuth({
      provider: "github",
      options: {
        redirectTo: redirect_url,
      },
    });
    if (error) throw error;
    return data;
  } catch (error) {
    console.error("GitHub OAuth error:", error);
    throw error;
  }
};

export const signInWithGoogle = async () => {
  const redirect_url = getRedirectUrl();
  
  if (!redirect_url || !redirect_url.startsWith("http")) {
    console.error("Invalid redirect URL:", redirect_url);
    throw new Error("Invalid redirect URL configuration");
  }
  
  try {
    const { data, error } = await supabase.auth.signInWithOAuth({
      provider: "google",
      options: {
        redirectTo: redirect_url,
      },
    });
    if (error) throw error;
    return data;
  } catch (error) {
    console.error("Google OAuth error:", error);
    throw error;
  }
};
